import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import Modal from 'src/components/ui/Modal'
import UIMessages from 'src/utils/ui-messages'
import history from '../../../../history'
import { IRefundTransactionDTO, IRiderObject } from '../../../../types'
interface IRefundTransactionModalProps {
  loading: boolean
  refundDetails: IRefundTransactionDTO
  refundedAmount: number
  path: string
  rider: IRiderObject
  getRefundedAmount: (stripeTransactionId: string, walletId: string) => any
  refundPayment: (params: IRefundTransactionDTO, refundableAmount: number) => void
}

export const RefundTransactionModal = (props: IRefundTransactionModalProps) => {
  if (!props.refundDetails) {
    return <div>no data</div>
  }
  const { balance } = props.rider.wallet.wallet
  const { stripeTransactionId, walletId, amount } = props.refundDetails
  const [showModal, setShowModal] = React.useState(true)
  const [refundableAmount, setRefundableAmount] = React.useState(0)
  const [refundAmount, setRefunedAmount] = React.useState(0)
  const [transactionMessage, setTransactionMessage] = React.useState('customer request')
  React.useEffect(() => {
    props.getRefundedAmount(stripeTransactionId, walletId)
  }, [])
  React.useEffect(() => {
    if (amount - props.refundedAmount >= balance) {
      onAmountUpdate(balance)
    } else if (amount - props.refundedAmount < balance) {
      onAmountUpdate(amount - props.refundedAmount)
    }
  }, [props.refundedAmount, amount, props.rider.wallet.wallet.balance])
  const onAmountUpdate = (amount: number) => {
    setRefundableAmount(amount)
    setRefunedAmount(amount / 100)
    if (amount <= 0) {
      history.goBack()
      history.go(0)
    }
  }
  const cancel = () => {
    history.goBack()
  }
  const onSubmit = () => {
    history.goBack()
    props.refundPayment(
      {
        ...props.refundDetails,
        amount: refundAmount * 100,
        transactionMessage
      },
      refundableAmount
    )
  }
  const setRefundAmount = (e: any) => {
    setRefunedAmount(e.target.value)
  }

  const setReason = (e: any) => {
    setTransactionMessage(e.target.value)
  }
  return (
    <div>
      {showModal && (
        <Modal>
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='bg-white col-4 p2'>
              <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>{UIMessages.common.refund}</span>
              <div className='mt1'>
                <div>
                  <div>Transaction ID:{props.refundDetails.stripeTransactionId}</div>
                  <div> Amount Left: ${refundableAmount / 100}</div>
                  <div>Amount in dollars</div>
                  <input type='number' value={String(refundAmount)} onChange={event => setRefundAmount(event)} />
                  <div>Reason</div>
                  <input value={transactionMessage} onChange={event => setReason(event)} />
                </div>
                <br />
                <button
                  type='button'
                  onClick={cancel}
                  className='CancelButton btn bg-white rounded font-light-grey mr2'
                >
                  {UIMessages.common.cancel}
                </button>
                <button
                  type='submit'
                  className='SubmitButton btn bg-green rounded font-white weight-300'
                  onClick={() => onSubmit()}
                >
                  <span className='flex items-center'>
                    <div className='font-white'>{UIMessages.cancelBillable.submitButton}</div>
                    {props.loading ? (
                      <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                    ) : (
                      <React.Fragment />
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/RefundTransactionModal.tsx